import { Route } from '@angular/router';
import {
    TenderContractDashboardIndexAnalysisListComponent
} from '../../../../../../../../pages';
import {TenderContractRoundIndexPriceAverageResolver}
from '../../../../../../../resolvers/tender-contract-round-index-price-average.resolver';

export const listRoute: Route = {
    path: 'list',
    component: TenderContractDashboardIndexAnalysisListComponent,
    resolve: {
        indexes: TenderContractRoundIndexPriceAverageResolver,
    },
};
